<div class="content-card">
  <div class="card-inner">
    <div class="font-semibold text-xl mb-4 module-name">
      Screen Master
    </div>
    <p-fluid>
      <p-table
        #dt
        [value]="viewModel.screens"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} screens"
        [globalFilterFields]="['name', 'description']"
        [rowHover]="true"
        dataKey="id"
        [tableStyle]="{ 'min-width': '75rem' }">
        <ng-template #caption>
          <div class="flex flex-col justify-between">
            <div class="flex flex-col items-end gap-3 flex-1">
              <div class="flex gap-2" *ngIf="viewModel.isSystemUser()">
                <p-button
                  label="Add"
                  icon="pi pi-plus"
                  severity="info"
                  (click)="viewModel.showCreateDialog()"
                  pTooltip="Create new screen with capture mode"
                  tooltipPosition="bottom"
                ></p-button>
              </div>
              <div class="search-container">
                <p-iconfield iconPosition="left">
                  <p-inputicon>
                    <i class="pi pi-search"></i>
                  </p-inputicon>
                  <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="Search..." />
                </p-iconfield>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th style="width: 20%">Screen Name</th>
            <th style="width: 30%">Description</th>
            <th style="width: 20%">Match Rules</th>
            <th style="width: 13%">Actions</th>
          </tr>
        </ng-template>
        <ng-template #body let-screen>
          <tr>
            <!-- <td>{{ screen.id }}</td> -->
            <td>{{ screen.name }}</td>
            <td>{{ screen.description }}</td>
            <td>
              <span class="text-sm">{{ viewModel.getRulesPreview(screen.matchRules || screen.modules) }}</span>
            </td>
            <!-- <td>{{ screen.createdOn | date: 'short' }}</td> -->
            <td>
              <p-button 
                icon="pi pi-pencil" 
                [rounded]="true"
                [outlined]="true"
                [raised]="true"
                severity="info"
                pTooltip="Edit"
                tooltipPosition="top"
                (onClick)="viewModel.showEditDialog(screen)"
                class="mr-2">
              </p-button>
              <p-button 
                icon="pi pi-trash" 
                [rounded]="true"
                [outlined]="true"
                [raised]="true"
                severity="danger"
                pTooltip="Delete"
                tooltipPosition="top"
                (onClick)="viewModel.deleteScreen(screen)">
              </p-button>
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="5" class="noData">No screens found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-fluid>
  </div>
</div>

<!-- Create/Edit Screen Dialog -->
<p-dialog 
  [(visible)]="viewModel.displayDialog" 
  [header]="viewModel.isEditMode ? 'Edit Screen' : 'Create Screen'"
  [modal]="true" 
  [style]="{ width: '700px' }"
  [dismissableMask]="false"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  styleClass="module-name scenario-dialog">
  
  <ng-template #content>
    <form class="p-fluid">
      <!-- Capture Button -->
      <div class="field mb-3 flex justify-end">
        <p-button 
          label="Capture Current Screen" 
          icon="pi pi-camera" 
          severity="info"
          [outlined]="true"
          [loading]="viewModel.isCapturing"
          (onClick)="viewModel.captureCurrentScreen()"
          pTooltip="Extract screen identifiers from currently open browser page"
          tooltipPosition="left">
        </p-button>
      </div>

      <!-- Captured Preview -->
      <div *ngIf="viewModel.capturedIdentifiers" class="field mb-3 p-3 surface-100 border-round">
        <div class="text-sm font-semibold mb-2">Captured Identifiers:</div>
        <div class="text-xs">
          <div><strong>Title:</strong> {{ viewModel.capturedIdentifiers.title || 'N/A' }}</div>
          <div><strong>Panel Headings:</strong> {{ viewModel.capturedIdentifiers.panelHeadings.join(', ') || 'None' }}</div>
          <div><strong>Breadcrumbs:</strong> {{ viewModel.capturedIdentifiers.breadcrumbs.join(' > ') || 'None' }}</div>
          <div><strong>Unique Widgets:</strong> {{ viewModel.capturedIdentifiers.uniqueWidgets.length }} detected</div>
        </div>
      </div>

      <div class="field mb-3">
        <label for="screenId" class="block font-medium mb-2">Screen ID</label>
        <input 
          id="screenId"
          type="text" 
          pInputText 
          [(ngModel)]="viewModel.screenId"
          name="screenId"
          placeholder="e.g., dashboard_home"
          class="w-full" />
        <small class="text-500 block mt-1">Stable identifier for programmatic reference</small>
      </div>

      <div class="field mb-3">
        <label for="screenName" class="block font-medium mb-2">Screen Name <span class="text-red-500">*</span></label>
        <input 
          id="screenName"
          type="text" 
          pInputText 
          [(ngModel)]="viewModel.screenName"
          name="screenName"
          placeholder="e.g., Dashboard Home"
          class="w-full" />
      </div>

      <div class="field mb-3">
        <label for="description" class="block font-medium mb-2">Description</label>
        <textarea 
          id="description"
          pTextarea
          [(ngModel)]="viewModel.description"
          name="description"
          rows="2"
          placeholder="Enter screen description"
          class="w-full">
        </textarea>
      </div>

      <div class="field mb-3">
        <label for="minMatch" class="block font-medium mb-2">Minimum Match Rules</label>
        <input 
          id="minMatch"
          type="number" 
          pInputText 
          [(ngModel)]="viewModel.minMatch"
          name="minMatch"
          [min]="1"
          class="w-full" />
        <small class="text-500 block mt-1">Number of rules that must match for screen detection (recommended: 2+)</small>
      </div>

      <div class="field mb-3">
        <div class="flex justify-between align-items-center mb-2">
          <label class="block font-medium">Match Rules <span class="text-red-500">*</span></label>
          <p-button 
            label="Add Rule" 
            icon="pi pi-plus" 
            [text]="true"
            size="small"
            (onClick)="viewModel.showAddRuleDialog()">
          </p-button>
        </div>

        <div class="border-1 border-300 border-round p-3">
          <div *ngIf="viewModel.matchRules.length === 0" class="text-center text-500 py-2">
            No rules added yet. Click "Capture Current Screen" or "Add Rule" to define detection rules.
          </div>
          
          <div *ngFor="let rule of viewModel.matchRules; let i = index" class="flex justify-between align-items-center mb-2 p-2 surface-50 border-round">
            <div class="flex-1">
              <span class="text-sm">{{ viewModel.getRuleDisplayText(rule) }}</span>
            </div>
            <div class="flex gap-1">
              <p-button 
                icon="pi pi-pencil" 
                [rounded]="true"
                [text]="true"
                size="small"
                severity="info"
                (onClick)="viewModel.showEditRuleDialog(rule, i)">
              </p-button>
              <p-button 
                icon="pi pi-trash" 
                [rounded]="true"
                [text]="true"
                size="small"
                severity="danger"
                (onClick)="viewModel.deleteRule(i)">
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #footer>
    <p-button 
      label="Cancel" 
      icon="pi pi-times" 
      severity="warn"
      (onClick)="viewModel.closeDialog()">
    </p-button>
    <p-button 
      [label]="viewModel.isEditMode ? 'Update' : 'Submit'" 
      icon="pi pi-check" 
      severity="success"
      (onClick)="viewModel.saveScreen()">
    </p-button>
  </ng-template>
</p-dialog>

<!-- Add/Edit Match Rule Dialog -->
<p-dialog 
  [(visible)]="viewModel.showRuleDialog" 
  [header]="viewModel.editingRuleIndex >= 0 ? 'Edit Match Rule' : 'Add Match Rule'"
  [modal]="true" 
  [style]="{ width: '550px' }"
  [dismissableMask]="false"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  styleClass="module-name scenario-dialog">
  
  <ng-template #content>
    <form class="p-fluid">
      <div class="field mb-3">
        <label for="ruleType" class="block font-medium mb-2">Rule Type <span class="text-red-500">*</span></label>
        <p-select 
          id="ruleType"
          [(ngModel)]="viewModel.ruleType"
          [options]="viewModel.ruleTypeOptions"
          optionLabel="label"
          optionValue="value"
          name="ruleType"
          placeholder="Select rule type"
          [appendTo]="'body'"
          class="w-full">
        </p-select>
      </div>

      <!-- Element Exists (data-automation-id) -->
      <div *ngIf="viewModel.ruleType === 'element_exists'" class="field mb-3">
        <label for="ruleSelector" class="block font-medium mb-2">Data Automation ID <span class="text-red-500">*</span></label>
        <input 
          id="ruleSelector"
          type="text" 
          pInputText 
          [(ngModel)]="viewModel.ruleSelector"
          name="ruleSelector"
          placeholder="e.g., panelSet, submitButton"
          class="w-full" />
        <small class="text-500 block mt-1">
          The value of data-automation-id attribute (without brackets)
        </small>
      </div>

      <!-- URL Contains -->
      <div *ngIf="viewModel.ruleType === 'url_contains'" class="field mb-3">
        <label for="ruleUrl" class="block font-medium mb-2">URL Fragment <span class="text-red-500">*</span></label>
        <input 
          id="ruleUrl"
          type="text" 
          pInputText 
          [(ngModel)]="viewModel.ruleUrl"
          name="ruleUrl"
          placeholder="e.g., /dashboard, myworkday.com"
          class="w-full" />
        <small class="text-500 block mt-1">
          Text that should appear in the URL
        </small>
      </div>

      <!-- Title/Heading/Breadcrumb Contains -->
      <div *ngIf="viewModel.ruleType === 'title_contains' || viewModel.ruleType === 'heading_contains' || viewModel.ruleType === 'breadcrumb_contains'" class="field mb-3">
        <label for="ruleText" class="block font-medium mb-2">Text to Match <span class="text-red-500">*</span></label>
        <input 
          id="ruleText"
          type="text" 
          pInputText 
          [(ngModel)]="viewModel.ruleText"
          name="ruleText"
          placeholder="Enter text to match"
          class="w-full" />
        <small class="text-500 block mt-1">
          <span *ngIf="viewModel.ruleType === 'title_contains'">Text that should appear in page title</span>
          <span *ngIf="viewModel.ruleType === 'heading_contains'">Text that should appear in panel headings</span>
          <span *ngIf="viewModel.ruleType === 'breadcrumb_contains'">Text that should appear in breadcrumb trail</span>
        </small>
      </div>
    </form>
  </ng-template>

  <ng-template #footer>
    <p-button 
      label="Cancel" 
      icon="pi pi-times" 
      severity="warn"
      (onClick)="viewModel.closeRuleDialog()">
    </p-button>
    <p-button 
      [label]="viewModel.editingRuleIndex >= 0 ? 'Update' : 'Add'" 
      icon="pi pi-check" 
      severity="success"
      (onClick)="viewModel.saveRule()">
    </p-button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>